/** Debounce GET work and suppress every callback from a superseded request,
 * including transports which finish after cancellation. Never used for writes. */
export function scheduleAccountRead<T>(
  load: (signal: AbortSignal) => Promise<T>,
  delay: number,
  complete: (data: T) => void,
  failed: (error: unknown) => void,
) {
  const controller = new AbortController();
  const timer = setTimeout(() => {
    void load(controller.signal).then(data => {
      if (!controller.signal.aborted) complete(data);
    }).catch(error => {
      if (!controller.signal.aborted) failed(error);
    });
  }, delay);
  return () => { clearTimeout(timer); controller.abort(); };
}
